export default __webpack_public_path__ + "static/media/Alerts.130057dc.png";